/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class LayerConfigurationModel {
        public gisDatastores: Wars.Domain.Model.Gis.GisDatastore[];
        public layers: Wars.Domain.Model.Gis.Layer[];

        constructor(private mapConfigurationService: services.MapConfigurationService,
            private systemLevelService: services.SystemLevelService,
            private deleteService: services.DeleteService,
            private gisDataStoreService: services.GisDatastoreService,
            private esriMapService:services.EsriMapService,
            private mapConfigurationId: string) {

            this.mapConfigurationService.getLayerConfigurations(mapConfigurationId).then(r => {
                this.layers = r;
            });

            gisDataStoreService.getGisDatastores().then(g => {
                this.gisDatastores = g;
            });
        }

        public addLayer() {
            console.log('Test');
            let newLayer = this.mapConfigurationService.createLayer();

            newLayer.name = "New Layer";
            newLayer.type = Wars.Domain.Model.Codes.Enums.LayerType.GisDataStore;
            newLayer.mapConfiguration_id = this.mapConfigurationId;
            newLayer.maxZoom = 18;
            newLayer.isQueryOnlyLayer = false;

            this.layers.push(newLayer);

            this.save();
        }

        public getMapServiceMetadata(layer: Wars.Domain.Model.Gis.Layer) {
            console.log(layer);

            this.esriMapService.getMapServiceMetadata(layer.url, layer.proxyUrl).then(r => {
                layer.esriMapServiceMetadata = r;
                console.log(layer);
                this.save();
            });
        }

        public save() {
            this.mapConfigurationService.saveAllChanges();
        }

        public removeLayer(layer: Wars.Domain.Model.Gis.Layer) {
            this.deleteService.deleteWithModalConfirmIfNecessary("Layer", layer.id, "Layer",() => {
                this.layers.remove(layer);
            });
        }
    }
}